import { GenericWorkboardProps } from './GenericWorkboard.props';
import { PaperStyled, RootContainer } from '../../../pages/Workboard/common/styles';

const GenericWorkboard = ({ children }: GenericWorkboardProps) => (
  <RootContainer>
    <PaperStyled>
      {children}
    </PaperStyled>
  </RootContainer>
);

export default GenericWorkboard;
